import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, JsonpModule   } from '@angular/http';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';

import { PlayersPage } from '../pages/players/players';
import { PlayerItem } from '../pages/players/playerItem';
import { ContactPage } from '../pages/contact/contact';
import { SettingsPage } from '../pages/settings/settings';
import { AddPlayer } from '../pages/settings/addPlayer';
import { PastGames } from '../pages/pastGames/pastGames';
import { PastGame } from '../pages/pastGames/pastGame';
import { Home } from '../pages/home/home';
import { Rounds } from '../pages/rounds/rounds';
import { Standings } from '../pages/standings/standings';
import { StarredStandings } from '../pages/starredStandings/starredStandings';
import { TabsPage } from '../pages/tabs/tabs';
import { CreateNgwGamePage } from '../pages/CreateNgwGame/CreateNgwGame';
import {MomentModule} from 'angular2-moment';
import {MyGlobals} from '../app/globals';

import { PicksFilter } from '../pages/rounds/picksFilter.ts';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { NgwScorerService } from '../app/ngwScorer.service';
import { NgwService } from '../app/ngw.service';
import {IndexedDBService} from '../providers/indexeddb.service'

import { Vibration } from '@ionic-native/vibration';

@NgModule({
  declarations: [
    MyApp,
    PlayersPage,
    PlayerItem,

    ContactPage,
    SettingsPage,
    TabsPage,
    PastGames,
    PastGame,
    AddPlayer,
    Home,
    Rounds,
    Standings,
    StarredStandings,
    CreateNgwGamePage,
    PicksFilter
  ],
  imports: [
    BrowserModule,
    HttpModule,
    JsonpModule,
    MomentModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    PlayersPage,
    PlayerItem,
    ContactPage,
    SettingsPage,
    PastGames,
    PastGame,
    TabsPage,
    AddPlayer,
    Home,
    Rounds,
    Standings,
    StarredStandings,
    CreateNgwGamePage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    NgwService,
    NgwScorerService,
    IndexedDBService,
    MyGlobals,
    Vibration,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts